<template>
  <div class="hab-input" :class="className">
    <div class="input">
      <label v-if="label" class="name"
        >{{ label }}<span v-if="required"></span
      ></label>
      <input
        :type="type"
        :disabled="disabled"
        :placeholder="placeholder"
        :value="value"
        @input="inputChange"
        @keyup="inputChange"
      />
    </div>
    <span v-if="error" class="alert-input-error">{{ error }}</span>
  </div>
</template>

<script>
export default {
  props: {
    className: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    value: {
      type: [String, Number],
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["onChange", "onEnter"],
  methods: {
    inputChange(e) {
      if (e?.key === "Enter" || e?.keyCode === 13) {
        // enter input
        return this.$emit("onEnter", e.target.value);
      }

      return this.$emit("onChange", e.target.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.hab-input {
  position: relative;
  .input {
    .name {
      font-size: 14px;
      font-weight: 500;
      line-height: 120%;
      margin: 0;
      margin-bottom: 10px;
      span {
        margin-left: 4px;
        &::before {
          content: "*";
          color: #f00;
        }
      }
    }
    input {
      width: 100%;
      border: 1px solid #d9d9d9;
      height: 28px;
      line-height: 28px;
      padding: 0 10px;
      border-radius: 4px;
      box-shadow: none;
      outline: none;
      &:focus,
      &:focus,
      &:hover {
        border-color: #40a9ff;
      }
    }
  }
}
</style>
